import AddToCartSimplifiedView from './AddToCartSimplifiedView';

export default AddToCartSimplifiedView;
